var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseReturnActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#89600F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4v16h16V4z",
    fill: "#89600F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5h-3v-2c0-.85-.65-1.5-1.5-1.5h-3C9.65 6 9 6.65 9 7.5v2H6c-.3 0-.5.2-.5.5v.1l.95 6.05c.05.5.5.85 1 .85h4.05v-1H7.45l-.85-5.5H18v-1zm-8-2c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v2h-4v-2z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 13.809h2.787l-.816-.938.321-.371L18 14.07l-1.375 1.571-.321-.37.821-.94h-2.792c-.351-.015-.694.142-.951.436-.258.294-.41.702-.424 1.135.013.432.166.84.423 1.135.258.295.6.452.952.436h1.833V18h-1.833c-.469.02-.925-.189-1.269-.582-.344-.393-.546-.937-.564-1.514.018-.576.221-1.12.565-1.513.343-.392.8-.6 1.268-.58v-.002z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseReturnActiveIcon);
export default __webpack_public_path__ + "static/media/purchaseReturnActiveIcon.684d700565f271ec42f7d768c160a6d4.svg";
export { ForwardRef as ReactComponent };